module.exports = __webpack_public_path__ + "img/Barlow-Black.33dba499.svg";